<template>
	<div class="key-result-form-row-layout">
		<div>
			<slot name="left-column"></slot>
		</div>
		<div>
			<slot name="right-column"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: "KeyResultFormRowLayout",
};
</script>

<style lang="scss" scoped>
.key-result-form-row-layout {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 1rem;

	> div {
		flex: 1;
	}

	@include for-size('md') {
		justify-content: space-evenly;
		flex-direction: row;
	}
}
</style>
